export default "assets/images/testimonial-portrait-b2e454dd.png";